<template>
  <div class="homeIndex">
    <HomeIndexCarousel />
    <HomeIndexNews />
    <HomeIndexGoodBusiness />

    <div class="HomeContainer">
      <div class="moduleTitle">
        <div class="divider"></div>
        {{l("精品现货")}}
        <div class="divider"></div>
      </div>
      <div style="display: flex">
        <el-image
          :src="($store.state.lang=='zh-CN'?'https://oss.chinaduancai.com/frontend/images/':'https://duancaiwang-i18n.oss-cn-hangzhou.aliyuncs.com/frontend/images/')+'index/image-advertising-quotation.jpg'"
          fit="cover"
          style="width: 220px; height: 330px; cursor: pointer"
          @click="$router.push('/home/quotation')"
        >
        </el-image>
        <div class="quotationContainer">
          <div
            v-for="item of quotationList"
            :key="item.code"
            class="quotationItem"
            @click="$router.push('/home/quotation/' + item.code)"
          >
            <div class="title_amount">
              <div class="title one_lines">
               <img :src="GetResourceUrl('flags/' + item.country.toLowerCase() + '.png')" style="width:20px;vertical-align: middle;" />
               <span style="vertical-align: middle;margin-left:6px;">{{ item.title }}</span>
              </div>
              <div class="amount one_lines">
                <template v-if="item.cheap_specification_price.price == '电议'">
                  {{l("价格电议")}}
                </template>
                <template v-else>
                  {{ item.cheap_specification_price.price }}{{l("元")}}/{{
                    l(item.cheap_specification_price.unit)
                  }}
                </template>
              </div>
            </div>
            <div class="expire_time"></div>
            <el-image :src="item.img_array[0]" fit="cover"></el-image>
            <div class="line one_lines">
              {{l("品质")}}： 
              <template v-if="item.character == 1">{{ l("正品现货") }}</template>
              <template v-if="item.character == 2">{{ l("二级余料") }}</template>
              <template v-if="item.character == 3">{{ l("正品余料") }}</template>
            </div>
            <div class="line one_lines">{{l("钢厂")}}：{{ item.steel_mill }}</div>
            <div class="line one_lines">{{l("发货地")}}：
               {{ item.address }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="HomeContainer">
      <div class="moduleTitle">
        <div class="divider"></div>
        {{l("热门求购")}}
        <div class="divider"></div>
      </div>
      <div style="display: flex">
        <el-image
          :src="($store.state.lang=='zh-CN'?'https://oss.chinaduancai.com/frontend/images/':'https://duancaiwang-i18n.oss-cn-hangzhou.aliyuncs.com/frontend/images/')+'index/image-advertising-purchase.jpg'"
          fit="cover"
          style="width: 220px; height: 330px; cursor: pointer"
          @click="$router.push('/home/purchase_material')"
        >
        </el-image>
        <div class="purchaseContainer">
          <div
            v-for="item of purchaseMaterialList"
            :key="item.code"
            class="purchaseItem"
            @click="$router.push('/home/purchase_material/' + item.code)"
          >
            <div class="title_amount">
              <div class="title one_lines">
               <img :src="GetResourceUrl('flags/' + item.country.toLowerCase() + '.png')" style="width:20px;vertical-align: middle;" />
               <span style="vertical-align: middle;margin-left:6px;">{{ item.title }}</span>
              </div>
              <div class="amount one_lines">
                {{ item.most_specification_amount.amount }}
                {{ l(item.most_specification_amount.unit) }}
              </div>
            </div>
            <div class="expire_time">
              {{l("截止日期")}}：{{ item.expire_time.slice(0, 10) }}
            </div>
            <div v-if="item.auth_count" class="line one_lines color-warning">
              {{ item.auth_count }}{{l("家已报价")}}
            </div>
            <div v-else class="line one_lines" style="color: #999">
              {{l("暂无报价")}}
            </div>
            <div class="line one_lines">{{l("钢厂")}}： {{ item.steel_mill }}</div>
            <div class="line one_lines">{{l("收货地")}}：
               {{ item.address }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="HomeContainer" v-if="raiseList.length">
      <div class="moduleTitle">
        <div class="divider"></div>
        {{l("钢厂拼单")}}
        <div class="divider"></div>
      </div>
      <div class="raiseContainer">
        <el-carousel
          height="190px"
          :interval="5000"
          :arrow="raiseList.length > 1 ? '' : 'never'"
          :indicator-position="raiseList.length > 1 ? '' : 'none'"
        >
          <el-carousel-item v-for="item of raiseList" :key="item.id">
            <router-link :to="'/home/raise/' + item.code" class="raiseItem">
              <el-image :src="item.img_array[0]" fit="cover"></el-image>

              <div class="detail">
                <div class="title one_lines">
                  {{ item.title }}
                </div>
                <div class="price one_lines">
                  {{ item.specification_amount[0].price }}{{l("元")}}/{{
                    l(item.specification_amount[0].unit)
                  }}
                </div>

                <div class="progressContainer">
                  <div class="progressBar">
                    <div
                      class="innerBar"
                      :style="{
                        width: (item.rate_amount / item.amount) * 100 + '%',
                      }"
                    ></div>
                  </div>
                  <div class="rate_amount">
                    <span class="color-warning"
                      >{{ item.rate_amount
                      }}{{ l(item.specification_amount[0].unit) }}</span
                    >/{{ item.amount }}{{ l(item.specification_amount[0].unit) }}
                  </div>
                </div>
                <div class="line">
                  {{l("起拼量")}}：{{ item.start_amount
                  }}{{ l(item.specification_amount[0].unit) }}
                </div>
                <div class="line" style="margin-top: 8px">
                  {{l("截止日期")}}：{{ item.expire_time.slice(0, 10) }}
                </div>
                <div class="btn">{{l("参与拼单")}}</div>
              </div>
            </router-link>
          </el-carousel-item>
        </el-carousel>
        <el-image
          :src="($store.state.lang=='zh-CN'?'https://oss.chinaduancai.com/frontend/images/':'https://duancaiwang-i18n.oss-cn-hangzhou.aliyuncs.com/frontend/images/')+'index/image-advertising-raise.jpg'"
          fit="cover"
          style="width: 472px; height: 186px; cursor: pointer"
          @click="$router.push('/home/raise')"
        >
        </el-image>
      </div>
    </div>
    <div class="HomeContainer">
      <div class="moduleTitle">
        <div class="divider"></div>
        {{l("锻件定制")}}
        <div class="divider"></div>
      </div>
      <el-image
        :src="($store.state.lang=='zh-CN'?'https://oss.chinaduancai.com/frontend/images/':'https://duancaiwang-i18n.oss-cn-hangzhou.aliyuncs.com/frontend/images/')+'index/image-advertising-forging.jpg'"
        fit="cover"
        style="width: 100%; height: 50px; cursor: pointer"
        @click="$router.push('/home/purchase_forging')"
      >
      </el-image>
      <div class="forgingOutContainer">
        <div class="forgingContainer">
          <div
            v-for="item of purchaseForgingList"
            :key="item.code"
            class="forgingItem"
            @click="$router.push('/home/purchase_forging/' + item.code)"
          >
            <el-image
              :src="item.img_array[0]"
              fit="cover"
              @click="$router.push('/home/purchase_forging')"
            ></el-image>
            <div class="title one_lines">
              <img :src="GetResourceUrl('flags/' + item.country.toLowerCase() + '.png')" style="width:20px;vertical-align: middle;" />
              <span style="vertical-align: middle;margin-left:6px;">{{ item.title }}</span>
            </div>
            <div class="detail">
              <div style="max-width: 100px">
                <div style="color: #7f7f7f; font-size: 12px">{{l("需求")}}</div>
                <div class="one_lines" style="margin-top: 8px">
                  <span class="color-warning" style="font-size: 20px">
                    {{ item.most_specification_amount.amount }}
                  </span>
                  <span style="font-size: 12px">
                    {{ item.most_specification_amount.unit }}
                  </span>
                </div>
              </div>
              <div style="text-align: center; max-width: 100px">
                <div style="color: #7f7f7f; font-size: 12px">{{l("截止日期")}}</div>
                <div
                  class="one_lines"
                  style="font-size: 12px; margin-top: 14px"
                >
                  {{ item.expire_time.slice(0, 10) }}
                </div>
              </div>
            </div>
            <div style="margin-left: 50px;overflow: hidden;white-space: nowrap;text-overflow: ellipsise;">
               {{ item.address }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeIndexCarousel from "./HomeIndexCarousel.vue";
import HomeIndexNews from "./HomeIndexNews.vue";
import HomeIndexGoodBusiness from "./HomeIndexGoodBusiness.vue";
export default {
  name: "HomeIndex",
  components: { HomeIndexCarousel, HomeIndexNews, HomeIndexGoodBusiness },
  data() {
    return {
      raiseList: [],
      quotationList: [],
      purchaseMaterialList: [],
      purchaseForgingList: [],
      beancurdList: [],
    };
  },
  created() {
    this.getQuotationList();
    this.getPurchaseMaterialList();
    this.getPurchaseForgingList();
    this.getRaiseList();
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    clickBeancurd(item) {
      window.open(item.path_pc);
    },
    getQuotationList() {
      this.axios
        .get("/api/visitor_quotation/recommend_list/", {
          params: {
            size: 4,
          },
        })
        .then((data) => {
          this.quotationList = data.map((item) => {
            try {
              item.img_array = JSON.parse(item.img_array);
            } catch (e) {
              console.error(e);
            }
            return item;
          });
        });
    },
    getPurchaseMaterialList() {
      this.axios
        .get("/api/visitor_purchase/recommend_list/", {
          params: {
            quality_type: 1,
            size: 4,
          },
        })
        .then((data) => {
          this.purchaseMaterialList = data.map((item) => {
            try {
              item.img_array = JSON.parse(item.img_array);
            } catch (e) {
              console.error(e);
            }
            return item;
          });
        });
    },
    getPurchaseForgingList() {
      this.axios
        .get("/api/visitor_purchase/recommend_list/", {
          params: {
            quality_type: 3,
            size: 8,
          },
        })
        .then((data) => {
          this.purchaseForgingList = data.map((item) => {
            try {
              item.img_array = JSON.parse(item.img_array);
            } catch (e) {
              console.error(e);
            }
            return item;
          });
        });
    },
    getRaiseList() {
      this.axios.get("/api/visitor_raise/recommend_list/").then((data) => {
        this.raiseList = data.map((item) => {
          try {
            item.img_array = JSON.parse(item.img_array);
          } catch (e) {
            console.error(e);
          }
          return item;
        });
      });
    },
  },
};
</script>


<style scoped lang="scss">
.homeIndex {
  background: #f1f1f1;
}
.moduleTitle {
  font-size: 32px;
  color: #666;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 35px 0;
  .divider {
    width: 478px;
    height: 1px;
    background: #b5b1b1;
    opacity: 0.37;
  }
}
.quotationContainer,
.purchaseContainer {
  width: 980px;
  display: flex;
  flex-wrap: wrap;
  background: #fff;
  .quotationItem,
  .purchaseItem {
    width: 490px;
    height: 165px;
    box-sizing: border-box;
    padding: 20px 32px;
    cursor: pointer;
    position: relative;
    &:nth-child(1) {
      border-bottom: 1px solid $borderPlainColor;
      border-right: 1px solid $borderPlainColor;
    }
    &:nth-child(2) {
      border-bottom: 1px solid $borderPlainColor;
    }
    &:nth-child(3) {
      border-right: 1px solid $borderPlainColor;
    }
    .title_amount {
      display: flex;
      font-size: 18px;
      .title {
        width: 300px;
      }
      .amount {
        color: $warningColor;
        width: 125px;
        text-align: right;
      }
    }
    .expire_time {
      color: #666;
      text-align: right;
      line-height: 32px;
      height: 32px;
    }
    .el-image {
      position: absolute;
      width: 106px;
      height: 73px;
      right: 32px;
      top: 72px;
    }
    .line {
      line-height: 20px;
      width: 300px;
      height: 20px;
      margin-bottom: 5px;
    }
  }
}

.raiseContainer {
  height: 220px;
  box-sizing: border-box;
  padding: 15px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  .el-carousel {
    width: 698px;
    .raiseItem {
      display: flex;
      //不同于raise列表页，el-carousel__item自带absolute
      // position: relative;
      .el-image {
        width: 208px;
        height: 186px;
      }
      .detail {
        width: 425px;
        height: 100%;
        margin-left: 34px;
        .title {
          font-size: 18px;
          margin-top: 10px;
        }
        .price {
          color: $warningColor;
          font-size: 18px;
          height: 35px;
          line-height: 35px;
          margin-top: 5px;
        }
        .progressContainer {
          margin-top: 20px;
          margin-right: 15px;
          margin-bottom: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 12px;
          .progressBar {
            max-width: 280px;
            flex-grow: 1;
            flex-shrink: 1;
            height: 4px;
            background: $borderPlainColor;
            border-radius: 5px;
            margin-right: 50px;

            overflow: hidden;
            .innerBar {
              border-radius: 5px;
              background: $warningColor;
              height: 100%;
            }
          }
          .rate_amount {
            flex-shrink: 0;
            letter-spacing: 0.5px;
            color: #999;
          }
        }
        .btn {
          border: 1px solid $warningColor;
          color: $warningColor;
          border-radius: 5px;
          text-align: center;
          width: 78px;
          height: 32px;
          line-height: 32px;
          box-sizing: border-box;
          position: absolute;
          bottom: 18px;
          right: 30px;
          cursor: pointer;
          &:hover {
            color: #fff;
            background: $warningColor;
          }
        }
      }
    }
    /deep/.el-carousel__indicators {
      position: absolute;
      right: 10px;
      top: -10px;
      left: auto;
      bottom: auto;
      .el-carousel__indicator {
        padding: 0 3px;
        &.is-active {
          .el-carousel__button {
            background: $warningColor;
          }
        }
        .el-carousel__button {
          background: #dedede;
          width: 18px;
          height: 3px;
        }
      }
    }
  }
}

.forgingOutContainer {
  background: #fff;
  padding: 20px;
  margin-top: 20px;
  .forgingContainer {
    outline: 1px solid $borderPlainColor;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    .forgingItem {
      width: 290px;
      height: 290px;
      outline: 1px solid $borderPlainColor;
      box-sizing: border-box;
      cursor: pointer;
      .el-image {
        width: 74px;
        height: 74px;
        margin-top: 35px;
        margin-left: 108px;
      }
      .title {
        text-align: center;
        margin-top: 10px;
        padding: 0 40px;
      }
      .detail {
        display: flex;
        justify-content: space-between;
        padding: 36px 50px 20px;
      }
    }
  }
}
</style>

